/** @format */

import React, { useCallback, useEffect, useState } from 'react';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { useDispatch } from 'react-redux';
import Filter from '../../../interfaces/forms/Filter';
import Order from '../../../interfaces/forms/Order';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { DISCOUNT_CONSTANTS } from '../../../modules/discounts/reducers';
import { Checkbox, makeStyles, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import oplStyle from '../../../assets/themes/OPL/OplStyle';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import withStyles from '@material-ui/core/styles/withStyles';
interface PlatformResellerSelectInterface {
    classes: any;
    setPr: (pr: Array<number>) => void;
    resellers: any;
    selected: Array<number> | null;
}
const PlatformResellerSelect = (props: PlatformResellerSelectInterface): React.ReactElement => {
    const { setPr, resellers, selected, classes } = props;
    const [selectedPr, setSelectedPr] = useState<Array<number>>(selected ?? []);

    const tableStickyHeader = { root: classes.tableStickyHeader };
    const tableCellRoot = { root: classes.tableCellRootBordered };
    const tableRowRoot = { root: classes.tableRowRoot };

    const check = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (event.target.checked) {
            const newElements = [...selectedPr, parseInt(event.target.name)];
            setSelectedPr(newElements);
        } else {
            let newElements = selectedPr.filter((item: any) => {
                return item !== parseInt(event.target.name);
            });
            setSelectedPr(newElements);
        }
    };

    useEffect(() => {
        setPr(selectedPr);
    }, [selectedPr, setPr]);

    return (
        <div>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell classes={tableStickyHeader} padding="none" align="center" style={{ width: 30 }}>
                            <I18n trans="notifications:welcome_sms.pr_name" />
                        </TableCell>
                        <TableCell classes={tableStickyHeader} padding="none" align="center">
                            <I18n trans="notifications:welcome_sms.pr_checked" />
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {resellers &&
                        resellers['hydra:member'].map((item: any) => {
                            return (
                                <TableRow classes={tableRowRoot} key={'key' + item.id}>
                                    <TableCell classes={tableCellRoot} style={{ width: 30 }} padding="none" align="left">
                                        {item.mainname}
                                    </TableCell>
                                    <TableCell classes={tableCellRoot} style={{ paddingLeft: 10 }} padding="none" align="left">
                                        <Checkbox checked={selectedPr.includes(item.id)} onChange={check} name={item.id} />
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                </TableBody>
            </Table>
        </div>
    );
};
export default withStyles(oplAppStyle)(PlatformResellerSelect);
